import { deleteDoc, doc, setDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/icons/back_arrow.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";
import { ReactComponent as Loading } from "../../assets/icons/loading.svg";
import { ReactComponent as Pencil } from "../../assets/icons/pencil.svg";
import { fetchThisTutorData } from "../../utils/fetchData";
import { db, storage } from "../../utils/firebase";
import Navbar from "../navbar";

const Profile = ({ user }) => {
  const navigate = useNavigate();
  const thisTutor = useSelector((state) => state.thisTutor.thisTutor);
  const thisUser = useSelector((state) => state.thisUser.user);
  const [image, setImage] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [deleteProfile, setDeleteProfile] = useState(false);
  const [appearCheckMark, setAppearCheckMark] = useState(false);
  const { state } = useLocation();
  const [tutorInfo, setTutorInfo] = useState({
    emailAddress: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    major: "",
    subjects: "",
    description: "",
    password: "",
    passwordConfirmation: "",
    profileImageUrl: thisTutor?.profileImageUrl,
    profileImage: null,
    uid: thisTutor?.uid || "defaultUID",
  });

  useEffect(() => {
    if (thisTutor) {
      setTutorInfo({
        emailAddress: thisTutor.contactInfo.emailAddress,
        phoneNumber: thisTutor.contactInfo.phoneNumber,
        firstName: thisTutor.firstName,
        lastName: thisTutor.lastName,
        major: thisTutor.major,
        subjects: thisTutor.specialization.join(),
        description: thisTutor.description,
        profileImage: null,
        profileImageUrl: thisTutor.profileImagePath,
      });
    }
  }, [thisTutor]);

  const infoHasChanged = () => {
    if (
      thisTutor.firstName !== tutorInfo.firstName ||
      thisTutor.lastName !== tutorInfo.lastName ||
      thisTutor.contactInfo.emailAddress !== tutorInfo.emailAddress ||
      thisTutor.contactInfo.phoneNumber !== tutorInfo.phoneNumber ||
      thisTutor.major !== tutorInfo.major ||
      thisTutor.specialization.join() !== tutorInfo.subjects ||
      thisTutor.description !== tutorInfo.description ||
      thisTutor.firstName !== tutorInfo.firstName ||
      tutorInfo.profileImage
    ) {
      return true;
    } else {
      return false;
    }
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const uploadImage = async (image) => {
    return new Promise((resolve, reject) => {
      const fileName = `${image.name} ${Math.random().toFixed(3)}`;
      const storageRef = ref(storage, `/Tutor-Images/${fileName}`);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
        },
        (err) => {
          console.log(err);
          alert(
            "Something went wrong. Please try again or check your picture format."
          );
          setUploading(false);
          reject(err);
        },
        async () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then(async (url) => {
            resolve(url);
          });
        }
      );
    });
  };

  const deleteTutorProfile = async () => {
    const thisTutorRef = doc(db, "tutors", thisTutor.id);
    await deleteDoc(thisTutorRef);
    // SG 08/08/2022 21:38  so that thisTutor will be null
    await fetchThisTutorData();
    navigate("/");
  };

  const saveInfo = async () => {
    if (!infoHasChanged()) return;

    setUploading(true);
    let imageUrl = tutorInfo.profileImageUrl;
    if (tutorInfo.profileImage) {
      // SG 08/08/2022 18:38  if user has changed profile image, then upload it first
      await uploadImage(tutorInfo.profileImage).then((url) => (imageUrl = url));
    }

    await setDoc(
      doc(db, "tutors", thisTutor.id),
      {
        firstName: capitalizeFirstLetter(tutorInfo.firstName),
        lastName: capitalizeFirstLetter(tutorInfo.lastName),
        contactInfo: {
          phoneNumber: tutorInfo.phoneNumber,
          emailAddress: tutorInfo.emailAddress,
        },
        description: tutorInfo.description,
        major: tutorInfo.major,
        profileImagePath: imageUrl,
        specialization: tutorInfo.subjects.split(","),
      },
      { merge: true }
    )
      .then(async () => {
        console.log("success!");
        await fetchThisTutorData();
        setUploading(false);

        setAppearCheckMark(true);
        setTimeout(() => {
          setAppearCheckMark(false);
        }, 1500);
      })
      .catch((e) => {
        alert(e.message);
        setUploading(false);
      });
  };

  useEffect(() => {
    if (document.getElementById("tutor-signup-description")) {
      document.getElementById("tutor-signup-description").style.height = "5px";
      document.getElementById("tutor-signup-description").style.height =
        document.getElementById("tutor-signup-description").scrollHeight + "px";
    }
  }, [tutorInfo.description]);

  if (!thisTutor) return null;

  return (
    <div>
      <Navbar user={user} />
      <div className="flex justify-center items-center flex-col mb-10 relative">
        <div className="flex justify-center items-center pt-[1em] md:pt-[5em] flex-col mb-10 relative">
          <div
            onClick={() => {
              navigate(state?.cameFrom || "/");
            }}
            className="p-2 cursor-pointer h-[2.8em] w-[2.8em] rounded-full hover:bg-gray-200 absolute top-[7em] left-0 flex justify-center items-center"
          >
            <BackArrow className="" />
          </div>
          <p className="text-[1.7em] md:text-[2em] font-semibold text-gray-700 mb-10">
            Edit Tutor Profile
          </p>
          <div className="relative hover:scale-[1.05] transition duration-300 ease-in-out group">
            <label htmlFor="profile-img-file-input">
              <div className="rounded-full bg-gray-500 absolute right-[.2em] shadow-md p-1 border-[1px] z-20">
                <Pencil className="text-white" />
              </div>
              <img
                alt="this user's profile"
                src={image || tutorInfo.profileImageUrl}
                className="object-fit w-[8em] h-[8em] rounded-full border-[3px]"
              />
            </label>
            <div
              className={`w-[8em] h-[8em] bg-gray-500 absolute rounded-full top-0 opacity-[0.4] pointer-events-none hidden group-hover:block`}
            />
            <input
              type="file"
              className="hidden"
              id="profile-img-file-input"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  setImage(URL.createObjectURL(e.target.files[0]));
                  setTutorInfo({
                    ...tutorInfo,
                    profileImage: e.target.files[0],
                  });
                }
              }}
            />
          </div>

          <form
            className="flex flex-col max-w-[300px] md:max-w-[700px] mt-10"
            onSubmit={async (e) => {
              e.preventDefault();
              await saveInfo();
              setUploading(false);
            }}
          >
            <p className="text-[1.15em] text-gray-600 font-semibold mb-3">
              Contact Information
            </p>

            <p className="text-[.9em] text-gray-600 font-medium mb-7">
              {`Changing this will not affect your login email, `}
              <span className="font-semibold">{thisUser.email}</span>
            </p>

            <div className="flex flex-1 justify-between flex-wrap gap-7 mb-[3em]">
              <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative">
                <p
                  className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                    tutorInfo?.emailAddress
                      ? "translate-x-0 -translate-y-6 bg-white "
                      : "translate-x-2"
                  }`}
                >
                  Email Address *
                </p>
                <input
                  required
                  type="email"
                  className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                  value={tutorInfo.emailAddress}
                  onChange={(e) =>
                    setTutorInfo({ ...tutorInfo, emailAddress: e.target.value })
                  }
                />
              </div>
              <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative">
                <p
                  className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                    tutorInfo?.phoneNumber
                      ? "translate-x-0 -translate-y-6 bg-white "
                      : "translate-x-2"
                  }`}
                >
                  Phone Number
                </p>
                <input
                  className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                  value={tutorInfo?.phoneNumber}
                  onChange={(e) =>
                    setTutorInfo({ ...tutorInfo, phoneNumber: e.target.value })
                  }
                />
              </div>
            </div>

            <p className="text-[1.15em] text-gray-600 font-semibold mb-5">
              Other information *
            </p>

            <div className="flex flex-1 justify-between flex-wrap gap-7 mb-7">
              <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative">
                <p
                  className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                    tutorInfo?.firstName
                      ? "translate-x-0 -translate-y-6 bg-white "
                      : "translate-x-2"
                  }`}
                >
                  First Name *
                </p>
                <input
                  required
                  className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                  value={tutorInfo?.firstName}
                  onChange={(e) =>
                    setTutorInfo({ ...tutorInfo, firstName: e.target.value })
                  }
                />
              </div>
              <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative">
                <p
                  className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                    tutorInfo?.lastName
                      ? "translate-x-0 -translate-y-6 bg-white "
                      : "translate-x-2"
                  }`}
                >
                  Last Name *
                </p>
                <input
                  required
                  className="flex-1 px-3 bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                  value={tutorInfo?.lastName}
                  onChange={(e) =>
                    setTutorInfo({ ...tutorInfo, lastName: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative mb-7">
              <p
                className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                  tutorInfo?.major
                    ? "translate-x-0 -translate-y-6 bg-white "
                    : "translate-x-2"
                }`}
              >
                Major *
              </p>
              <input
                required
                className="flex-1 px-3 w-full bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                value={tutorInfo?.major}
                onChange={(e) =>
                  setTutorInfo({ ...tutorInfo, major: e.target.value })
                }
              />
            </div>

            <div className="rounded-xl py-3 pl-2 border-[2px] bg-white relative mb-7">
              <p
                className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                  tutorInfo?.subjects
                    ? "translate-x-0 -translate-y-6 bg-white "
                    : "translate-x-2"
                }`}
              >
                Subjects (Seprated by commas) *
              </p>
              <input
                required
                className="flex-1 px-3 w-full bg-transparent outline-none text-gray-800 text-[1.1em] font-medium"
                value={tutorInfo?.subjects}
                onChange={(e) =>
                  setTutorInfo({ ...tutorInfo, subjects: e.target.value })
                }
              />
            </div>

            <div className="rounded-xl py-3 min-h-[5em] pl-2 border-[2px] bg-white relative">
              <p
                className={`bg-white mx-2 px-1 pointer-events-none absolute translate-x-4 text-gray-600 font-medium transition duration-200 ease-in-out hover ${
                  tutorInfo?.description
                    ? "translate-x-0 -translate-y-6 bg-white "
                    : "translate-x-2"
                }`}
              >
                Your description, greetings*
              </p>
              <textarea
                required
                id="tutor-signup-description"
                className="flex-1 px-3 w-full bg-transparent h-auto outline-none text-gray-800 text-[1.1em] font-medium resize-none"
                value={tutorInfo?.description}
                onChange={(e) =>
                  setTutorInfo({ ...tutorInfo, description: e.target.value })
                }
              />
            </div>

            <p id="tutor-signup-form-error-msg" className="text-red-500"></p>
            <button
              type="submit"
              className="p-3 flex relative justify-center items-center bg-black text-white h-[3.5em] rounded-sm mt-10 font-semibold transition duration-300 ease-in-out hover:scale-[1.03]"
            >
              {uploading ? (
                <Loading className="animate-spin" color="white" />
              ) : (
                <p className={`${appearCheckMark ? "hidden" : "block"}`}>
                  Save Info
                </p>
              )}
              <Check className={`${appearCheckMark ? "w-8 h-8" : "w-0 h-0"}`} />
            </button>
          </form>
          <p
            className="text-red-500 mt-10 cursor-pointer"
            onClick={() => setDeleteProfile(!deleteProfile)}
          >
            Delete my Tutor Profile
          </p>

          <div
            className={`z-30 bg-white rounded-lg min-w-[300px] shadow-lg absolute left-[50%] top-[78%] -translate-x-[50%] -translate-y-[50%] p-8 border-[1px] transition duration-300 ease-in-out ${
              deleteProfile
                ? "scale-[1]"
                : "scale-[0] translate-y-[6em] md:translate-y-[3.1em]"
            }`}
            id="delete-tutor-profile-form"
          >
            <p className="text-[1.15em] text-gray-600 font-semibold mb-3">
              Are you sure?
            </p>
            <p>
              By deleting your tutor profile, others will NOT be able to see you
              and your personal data will be erased. However this will not
              delete your Kuwait CU login credentials so you will still be able
              to use our other services.
            </p>
            <div className="flex justify-between w-full mt-5">
              <div
                className="bg-gray-200 text-gray-600 px-6 py-[.5em] rounded-lg cursor-pointer"
                onClick={() => setDeleteProfile(false)}
              >
                Cancel
              </div>
              <div
                className="bg-red-500 text-white px-6 py-[.5em] rounded-lg cursor-pointer"
                onClick={deleteTutorProfile}
              >
                Delete
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
